import { ApiClientErrorResponse } from '~/ApiClient';

import UnavailableDateError from './UnavailableDateError';

const UnavailableDateErrorCode = 'custom-user-exchange-rates-unavailable-date';

export default class RatesErrorResponse extends ApiClientErrorResponse {
	handleUnavailableDate() {
		return this.handle(UnavailableDateErrorCode);
	}

	findUnvailableDateError(): UnavailableDateError | null {
		const error = this.errors.find((candidate) => candidate.code === UnavailableDateErrorCode);
		return error !== undefined && Array.isArray(error.meta.suggestedDates)
			? new UnavailableDateError(error.meta.suggestedDates.map((date) => new Date(date)))
			: null;
	}
}
